<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import { debounce } from "@/helpers/debounce";
import { defineAsyncComponent } from "vue";
import axios from "axios";
import Swal from "sweetalert2";

const FormDetail = defineAsyncComponent(async () => {
  await new Promise((r) => setTimeout(r, 500));
  return import("./detail-finalisasi.vue");
});

export default {
  page: {
    title: "Finalisasi Pembelajaran",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    FormDetail,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "pbl_id" },
      { width: "auto", label: "Kode", name: "pbl_kode" },
      { width: "auto", label: "Judul", name: "pbl_judul" },
      { width: "auto", label: "Durasi HE", name: "pbl_durasi_he" },
      { width: "auto", label: "Durasi JP", name: "pbl_durasi_jp" },
      { width: "auto", label: "Tipe", name: "pbl_lt_name" },
      { width: "auto", label: "Peserta", name: "pbl_jml_peserta" },
      { width: "auto", label: "Tanggal Mulai", name: "pbl_tgl_mulai" },
      { width: "auto", label: "Tanggal Selesai", name: "pbl_tgl_selesai" },
      { width: "100px", label: "Status", name: "-" },
      { width: "250px", label: "Aksi", name: "-" }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Finalisasi Pembelajaran",
      items: [
        {
          text: "Data Pembelajaran",
          href: "/",
        },
        {
          text: "Finalisasi Pembelajaran",
          active: true,
        },
      ],
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,

      showDetail: false,
      idData: null,

      // variable Page Table
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "pbl_id", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",

      // parsing data ke table data
      tableData: {
        draw: 0,
        length: 10,
        search: "",
        column: 0,
        dir: "asc",
        filter_status: "SEMUA DATA",
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  created() {
    this.searchDatatable = debounce(() => {
      this.getDataTable();
      // call fetch API to get results
    }, 500);
  },
  mounted() {
    let self = this;
    self.cekAksesMenu();
    self.getDataTable();
  },
  methods: {
    cekAksesMenu() {
      let self = this;
      var config_axios = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "auth/check-access-menu",
        params: {
          role_id: self.sessionRoleId,
          link_name: self.namePathUrl,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config_axios)
        .then((response) => {
          let response_data_fix = response.data.data.status_access;
          if (response.data.meta.code == 200) {
            if (response_data_fix == false) {
              Swal.fire({
                icon: "warning",
                title: "Oppss",
                text: "Mohon maaf anda tidak diberikan akses pada halaman ini.",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
              }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                  self.$router.push({ name: "dashboard" });
                }
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION +
        "transactions/pembelajaran"
    ) {
      let self = this;
      self.loadingTable = true;
      self.tableData.draw++;

      var config = {
        method: "get",
        url: url,
        params: self.tableData,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data[0];
          if (response_data.meta.code == 200) {
            if (self.tableData.draw == response_data_fix.draw) {
              // self.table_data = response_data_fix.list_data.data;
              var obj = {
                pbl_id_encrypt: 2,
                pbl_kode: 123,
                pbl_judul: "asd",
                pbl_durasi_he: "10",
                pbl_durasi_jp: "10",
                pbl_lt_name: "ITN",
                pbl_jml_peserta: "5",
                pbl_tgl_mulai: "2023-05-08",
                pbl_tgl_selesai: "2023-05-12",
                status: "FINALISASI",
              };

              self.table_data.push(obj);
              self.configPagination(response_data_fix.list_data);
              self.currentTablePage = response_data_fix.list_data.current_page;

              console.log(self.table_data);
            }
            self.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      let self = this;
      self.pagination.lastPage = data.last_page;
      self.pagination.currentPage = data.current_page;
      self.pagination.total = data.total;
      self.pagination.lastPageUrl = data.last_page_url;
      self.pagination.nextPageUrl = data.next_page_url;
      self.pagination.prevPageUrl = data.prev_page_url;
      self.pagination.from = data.from;
      self.pagination.to = data.to;
      self.pagination.links = data.links;
    },
    sortBy(key) {
      let self = this;
      self.sortKey = key;
      self.sortOrders[key] = self.sortOrders[key] * -1;
      self.tableData.column = self.getIndex(self.columns, "name", key);
      self.tableData.dir = self.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage: function (str) {
      let self = this;
      self.getDataTable(str);
    },
    changeStatusData(status, id) {
      let self = this;

      let text_alert = "";
      if (status == "DRAFT") {
        text_alert = "Apakah anda yakin ingin memperbaiki data tersebut?";
      } else {
        text_alert = "Apakah anda yakin ingin memverifikasi data tersebut?";
      }

      Swal.fire({
        title: "Perhatian",
        text: text_alert,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          self.loadingTable = true;
          Swal.fire({
            title: '<i class="fa fa-refresh fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
          });

          var config = {
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "transactions/pembelajaran",
            data: {
              id: id,
              status: status,
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          };
          axios(config).then((response) => {
            var response_data = response.data;
            if (response_data.meta.code != "200") {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil diperbarui.",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                  self.getDataTable();
                  self.showAlat = false;
                }
              });
            }
          });
        } else {
          Swal.close();
        }
      });
    },
    deleteData(id) {
      let self = this;
      Swal.fire({
        title: "Perhatian",
        text: "Anda yakin ingin menghapus data tersebut?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          self.loadingTable = true;
          Swal.fire({
            title: '<i class="fa fa-refresh fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
          });

          var config = {
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "transactions/pembelajaran",
            data: {
              id: id,
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          };
          axios(config).then((response) => {
            var response_data = response.data;
            if (response_data.meta.code != "200") {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil dihapus.",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                  self.getDataTable();
                }
              });
            }
          });
        } else {
          Swal.close();
        }
      });
    },
    detailData(id) {
      let self = this;
      self.showDetail = false;
      // config untuk re render component
      self.$nextTick(() => {
        self.idData = id;
        self.showDetail = true;
      });
    },
  },
};
</script>
<style>
th {
  border-color: grey !important;
}

td {
  border-color: grey !important;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-6">
                <div class="card-title">Semua Data Finalisasi Pembelajaran</div>
              </div>
              <div class="col-md-6">
                <div class="d-flex justify-content-end mb-3">
                  <div class="d-flex ps-2">
                    <!-- <router-link
                      :to="{ name: 'add-perencanaan-pembelajaran' }"
                      class="btn btn-sm btn-success"
                      ><i class="fa fa-plus"></i> Tambah</router-link
                    > -->
                    <button class="btn btn-sm btn-success" type="button">
                      <i class="fa fa-download me-1"></i> Download Laporan
                      Pembelajaran
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <hr />
                <div class="row">
                  <div class="form-group col-md-2">
                    <label for="statusTable">Status</label>
                    <select class="form-select" id="statusTable" v-model="tableData.filter_status" @change="getDataTable()">
                      <option value="SEMUA DATA">SEMUA DATA</option>
                      <option value="DRAFT">DRAFT</option>
                      <option value="TERVERIFIKASI">TERVERIFIKASI</option>
                    </select>
                  </div>
                </div>
                <hr />
              </div>
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-4">
                    <table>
                      <tr>
                        <td>Show</td>
                        <td>
                          <select class="form-control form-control-sm" id="showpaginatetable" style="width: 100%" v-model="tableData.length" @change="getDataTable()">
                            <option value="10" selected>10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                          </select>
                        </td>
                        <td>Entries</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-md-5">&nbsp;</div>
                  <div class="col-md-3">
                    <input type="text" class="form-control form-control-sm" id="searchTable" placeholder="Cari Data ..." v-model="tableData.search" @input="searchDatatable" />
                  </div>
                </div>
              </div>
              <datatable :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="11">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="table_data == ''">
                    <td class="text-center" colspan="11">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr v-else v-for="(row_data, key_data) in table_data" :key="key_data">
                    <td class="text-center">
                      <div v-if="key_data + 1 == 10">
                        {{ currentTablePage }}0.
                      </div>
                      <div v-else>
                        {{
                          currentTablePage - 1 != 0 ? currentTablePage - 1 : ""
                        }}{{ key_data + 1 }}.
                      </div>
                    </td>
                    <td>
                      {{ row_data.pbl_kode }}
                    </td>
                    <td>
                      {{ row_data.pbl_judul }}
                    </td>
                    <td class="text-center">
                      {{ row_data.pbl_durasi_he }}
                    </td>
                    <td class="text-center">
                      {{ row_data.pbl_durasi_jp }}
                    </td>
                    <td class="text-center">
                      {{ row_data.pbl_lt_name }}
                    </td>
                    <td class="text-center">
                      {{ row_data.pbl_jml_peserta }}
                    </td>
                    <td class="text-center">
                      {{ row_data.pbl_tgl_mulai }}
                    </td>
                    <td class="text-center">
                      {{ row_data.pbl_tgl_selesai }}
                    </td>
                    <td class="text-center">
                      <div v-if="row_data.status == 'FINALISASI'">
                        <div class="badge badge-pill badge-soft-success font-size-12">
                          FINALISASI
                        </div>
                      </div>
                      <div v-else>
                        <div class="badge badge-pill badge-soft-danger font-size-12">
                          DRAFT
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div>
                        <div class="btn-group">
                          <button type="button" class="btn btn-success btn-sm">
                            <i class="bx bx-download"></i> Download Template
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </datatable>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Detail Data Finalisasi Pembelajaran -->
    <b-modal v-model="showDetail" title="Detail Data Finalisasi Pembelajaran" title-class="text-black font-18" body-class="p-3" size="xl" hide-footer>
      <form-detail v-if="showDetail" :idData="idData"></form-detail>
    </b-modal>
  </Layout>
</template>
